










import Vue from "vue";
import { Prop } from "vue/types/options";
import { AreaType } from "throne-api";

import Icon from "@/components/icon.vue";
import IconAreaType from "@/components/icon-area-type.vue";

export default Vue.extend({
  name: "components-header-area-type",
  components: {
    Icon,
    IconAreaType,
  },
  props: {
    areaType: { type: String as Prop<AreaType>, required: true },
    areaTypeName: { type: String, required: true },
    isExpandable: { type: Boolean, required: false, default: true },
    isExpanded: { type: Boolean, required: false, default: false },
  },
  methods: {
    toggleExpand(): void {
      if (this.isExpandable) {
        this.$emit("toggleExpand");
      }
    },
  },
});
